import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgLock = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5 11.0001C5 10.4478 5.44772 10.0001 6 10.0001H18.6667C19.219 10.0001 19.6667 10.4478 19.6667 11.0001V21.0001C19.6667 21.5524 19.219 22.0001 18.6667 22.0001H6C5.44772 22.0001 5 21.5524 5 21.0001V11.0001Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.66687 10V6.66667C7.66687 5.42899 8.15854 4.242 9.0337 3.36684C9.90887 2.49167 11.0959 2 12.3335 2C13.5712 2 14.7582 2.49167 15.6334 3.36684C16.5085 4.242 17.0002 5.42899 17.0002 6.66667V10"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3332 15.3333C12.2673 15.3333 12.2028 15.3529 12.148 15.3895C12.0932 15.4261 12.0505 15.4782 12.0253 15.5391C12 15.6 11.9934 15.667 12.0063 15.7317C12.0191 15.7963 12.0509 15.8557 12.0975 15.9024C12.1441 15.949 12.2035 15.9807 12.2682 15.9936C12.3328 16.0064 12.3999 15.9998 12.4608 15.9746C12.5217 15.9494 12.5737 15.9067 12.6104 15.8518C12.647 15.797 12.6665 15.7326 12.6665 15.6666C12.6667 15.6228 12.6581 15.5794 12.6414 15.5389C12.6247 15.4985 12.6002 15.4617 12.5692 15.4307C12.5382 15.3997 12.5014 15.3752 12.4609 15.3584C12.4204 15.3417 12.377 15.3332 12.3332 15.3333V15.3333Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgLock.displayName = 'SvgLock';
export default SvgLock;
